/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `CUSTOM` - Custom
 *   * `PACKAGE` - Package
 * ```
 */
export const OrderSelectionTypesEnum = { CUSTOM: 'CUSTOM', PACKAGE: 'PACKAGE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderSelectionTypesEnum = ValuesOf<typeof OrderSelectionTypesEnum>;

export type OrderSelectionTypesEnumRequest = OrderSelectionTypesEnum;
export type OrderSelectionTypesEnumResponse = OrderSelectionTypesEnum;
